import 'react-native-svg';

export * from '../bot-sdk/constants/Constant';
export * from '../bot-sdk/theme/IThemeType';
export * from '../bot-sdk/templates/BotTemplate';
export * from '../bot-sdk/templates/CustomTemplate';

export {default as BotTemplate} from '../bot-sdk/templates/BotTemplate';
//import BotTemplate from '../bot-sdk/templates/BotTemplate';

import KoreChat from '../bot-sdk/chat/KoreChat';

export {default as QuickReplies} from '../bot-sdk/templates/QuickReplies';

export {default as CustomTemplate} from '../bot-sdk/templates/CustomTemplate';

export default KoreChat;
